import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/software/hrm")({ beforeLoad: redirectTo("/software/hrm-payroll") });
